webpackJsonp([1],{

/***/ "+dZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__("HJCT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6399b442_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__("nPgr");
function injectStyle (ssrContext) {
  __webpack_require__("YaHo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6399b442"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6399b442_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/Yym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountTransactionTable_vue__ = __webpack_require__("6txk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd966f38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountTransactionTable_vue__ = __webpack_require__("k8NQ");
function injectStyle (ssrContext) {
  __webpack_require__("Q4RD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bd966f38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccountTransactionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd966f38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccountTransactionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/vXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode__ = __webpack_require__("jB/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_barcode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'extra-event',
  props: ['extra'],
  components: {
    'barcode': __WEBPACK_IMPORTED_MODULE_0_vue_barcode___default.a
  },
  computed: {
    isEmpty: function isEmpty() {
      return this.$_.isEmpty(this.extra);
    },
    isDeployVendor: function isDeployVendor() {
      return !this.$_.isEmpty(this.extra) && this.extra.method === 'deployVendor';
    },
    isProduct: function isProduct() {
      return !this.$_.isEmpty(this.extra) && this.extra.method === 'deployProduct';
    },
    isAddOperation: function isAddOperation() {
      return !this.$_.isEmpty(this.extra) && this.extra.method === 'addOperation';
    },
    args: function args() {
      return this.extra.arguments;
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0Ya+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0smJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticker_vue__ = __webpack_require__("O0x4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c7efac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticker_vue__ = __webpack_require__("WM8Y");
function injectStyle (ssrContext) {
  __webpack_require__("wh/e")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15c7efac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ticker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15c7efac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ticker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1IK8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1O7p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBar_vue__ = __webpack_require__("M7uO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dac00f34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBar_vue__ = __webpack_require__("ouk2");
function injectStyle (ssrContext) {
  __webpack_require__("HHKP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dac00f34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dac00f34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1ccB":
/***/ (function(module, exports) {

module.exports = {"ad":{"title":"📢あなたのプロジェクトを {coin} に広告する!","content":"コミュニティ広告を使用して月額料金の低い {coin} プロジェクトを見つけましょう。","footer":"コミュニティー広告"},"nav":{"faq":"よくある質問","network_stats":"ネットワーク統計","blocks":"ブロック","representatives":"代表者","document":"ドキュメント","search_prompt":"アドレス、ブロックハッシュ","search":"検索"},"network":{"num_of_blocks":"NUMBER OF BLOCKS","num_of_frontiers":"NUMBER OF FRONTIERS","connected_peers":"CONNECTED PEERS","tx":"TX/SEC (30 MIN AVG)"},"table":{"account":"アカウント","amount":"金高","block_hash":"ブロックハッシュ","block_number":"ブロック番号","date":"時刻","difficulty":"Difficulty","extra_data":"Extra Data","from":"From","gas":"Gas","gas_limit":"Gas Limit","gas_price":"Gas Price","gas_used":"Gas Used","hash":"Hash","name":"名前","nonce":"Nonce","number":"Number","parent":"Parent","receive":"受け取る","send":"送る","size":"Size","to":"To","type":"種類","contract_creation":"コントラクト作成","contract_invoke":"コントラクトを実行","contract_exec_success":"コントラクトを実行成功しました","contract_exec_failed":"コントラクトを実行失敗しました","is_contract":"このトランザクションはコントラクトのデプロイです"},"res":{"latest_transactions":"最新のトランザクション","more":"もっと","slogan":"{coin} ネットワークを分散させるのに役立ちます！","slogan_address":"アカウント担当者を {coin} の担当者に設定します。","market_data":"市場データ","live":"LIVE","market_name":"CoinMarketCap","market_desc":"{coin} は現在 {link} でランク #{rank} です。循環供給量の合計は 1,145,148,101,919 {coin} であり、これは決して増加しません。","market_cap":"MARKET CAP","change_24h":"CHANGE (24H)","change_7d":"CHANGE (7D)","price_usd":"PRICE (USD)","price_btc":"PRICE (BTC SATOSHI)","volume_24h":"24H VOLUME","netstat_desc":"{block} は、送信、受信、またはオープントランザクションを表します。 {frontier} はウォレット内の1つの口座を表します。 {tx} は理論的には最大 7,000tx/s の容量を持つネットワークの総スループットです。","block":"ブロック","tx_per_sec":"Tx/sec","frontier":"frontier","representative_desc":"どこから始めるべきかわからない？ ここにチェックアウトするいくつかの興味深いアカウントがあります。","json_rep":"JSON 表現"},"faq":{"title":"よくある質問","q_what_is":"{coin} とは何ですか？","a_what_is":"{coin} は、JZM.io によって作成された次世代の暗号化方式で、事実上即座のトランザクションと手数料なしで利用できます。 これは、ブロック格子技術を使用して、セキュリティを犠牲にすることなく高速分散処理を可能にします。"},"blocks":{"blocks":"ブロック","desc":"ブロックは、ネットワーク内のトランザクションを表します。 ドキュメントのブロックについて詳しくは、こちらをご覧ください。","total_blocks":"合計ブロック数","current_block_count":"CURRENT BLOCK COUNT"},"doc":{"key_concepts":"主なコンセプト","introduction":"序論"},"account":{"anonymous":"匿名アカウント","contract":"コントラクト","creator":"クリエイター","from_transaction":"源トランザクション","pending":"保留中のトランザクション","send":"send","receive":"receive","pending_desc":"これは、アカウント保有者がトランザクションを完了するための {receive} ブロックをまだ公開していない着信 {send} ブロックのリストです。","pending_note":"注：保留中の送信トランザクションのみが表示され、最大20件が特定の順序で表示されます。","no_pending":"保留中のトランザクションはありません。","completed":"{count} 完了したトランザクション","update":"このアカウントは {date} に更新されました","voting_title":"投票の重み係数","voting_content":"このアカウントは、{weight} 投票の重み係数を有します。"},"transaction":{"transaction":"トランザクション"},"block":{"block":"ブロック","transactions":"このブロックには {count} 個のトランザクションが含まれています"}}

/***/ }),

/***/ "4iK/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Docs_vue__ = __webpack_require__("t8v2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8007e6aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Docs_vue__ = __webpack_require__("rHiN");
function injectStyle (ssrContext) {
  __webpack_require__("q2vy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8007e6aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Docs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8007e6aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Docs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4k2Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nprogress-container'),_vm._v(" "),_c('nav-bar'),_vm._v(" "),_c('status-bar',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]}),_vm._v(" "),_c('main-content'),_vm._v(" "),_c('footer-bar'),_vm._v(" "),(_vm.shouldShowPageLoader)?_c('div',{staticClass:"pageloader",class:{ 'is-active': _vm.isLoading }},[_c('span',{staticClass:"title"},[_vm._v("\n      Loading "+_vm._s(_vm.pageName)+"\n    ")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "54Zq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "564C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xkeshi_vue_qrcode__ = __webpack_require__("8Vd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_barcode__ = __webpack_require__("jB/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_barcode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_barcode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Contract',
  components: {
    'QRCode': __WEBPACK_IMPORTED_MODULE_1__xkeshi_vue_qrcode__["a" /* default */],
    'barcode': __WEBPACK_IMPORTED_MODULE_2_vue_barcode___default.a
  },
  mounted: function mounted() {
    this.$store.dispatch('loadContract', this.$route.params.hash.toLowerCase());
  },
  data: function data() {
    return {
      isShowingQR: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['contract']), {
    isEmpty: function isEmpty() {
      return this.contract.name === undefined;
    },
    qrAddress: function qrAddress() {
      return window.location.protocol + '//' + window.location.host + '/#/tx/' + this.$route.params.hash;
    }
  })
});

/***/ }),

/***/ "5SWH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTable_vue__ = __webpack_require__("YA7m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7fcba5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTable_vue__ = __webpack_require__("uKUK");
function injectStyle (ssrContext) {
  __webpack_require__("1IK8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e7fcba5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e7fcba5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5rmT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('div',{staticClass:"section is-hidden-mobile"},[_c('Carousel')],1),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-flex section-title bg-tx"},[_c('h2',{staticClass:"has-text-info is-marginless"},[_vm._v(_vm._s(_vm.$t("res.latest_transactions")))]),_vm._v(" "),_c('p',{staticClass:"is-marginless"},[_vm._v(_vm._s(_vm.$t("res.more")))]),_vm._v(" "),_c('a',{staticClass:"is-marginless is-flex",attrs:{"href":"#/ticker"}},[_c('img',{attrs:{"src":__webpack_require__("uty8"),"alt":"More..."}})])]),_vm._v(" "),_c('transaction-table')],1)])]),_vm._v(" "),_c('section',{staticClass:"is-hidden"},[_c('div',{staticClass:"notification is-light"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.$t("res.slogan", {coin: this.$CoinName})))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("res.slogan_address", {coin: this.$CoinName})))]),_vm._v(" "),_c('code',{staticClass:"has-background-light is-size-5"},[_vm._v("29ddee7880d6dd82324674776cae452c3cba13fd")])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-flex section-title bg-stat"},[_c('h2',{staticClass:"has-text-info is-marginless"},[_vm._v(_vm._s(_vm.$t("nav.network_stats")))])])]),_vm._v(" "),_c('network-status')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5vOt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'status-bar',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['chainStatus']), {
    blocks: function blocks() {
      return this.$utils.addComma(this.chainStatus.blockHeight);
    },
    lastBlockTime: function lastBlockTime() {
      if (this.chainStatus.lastBlockTime) {
        var last = this.chainStatus.lastBlockTime;
        var d = new Date();
        var now = d.getTime();
        if (now / 1000 - last < 30) {
          return '' + parseInt(now / 1000 - last) + 's';
        } else {
          return this.$utils.fromNow(last);
        }
      }
    },
    transactionPerSecond: function transactionPerSecond() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3);
    }
  })
});

/***/ }),

/***/ "6DhF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__xkeshi_vue_qrcode__ = __webpack_require__("8Vd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_AccountTransactionTable__ = __webpack_require__("/Yym");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_LiveTag__ = __webpack_require__("UO/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Account',
  components: { LiveTag: __WEBPACK_IMPORTED_MODULE_3__components_layout_LiveTag__["a" /* default */], AccountTransactionTable: __WEBPACK_IMPORTED_MODULE_2__components_layout_AccountTransactionTable__["a" /* default */], qrcode: __WEBPACK_IMPORTED_MODULE_1__xkeshi_vue_qrcode__["a" /* default */] },
  mounted: function mounted() {
    this.$store.dispatch('loadAccount', this.$route.params.account);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])(['account']), {
    isContract: function isContract() {
      var a = this.account;
      return a && a.contract && a.contract.address;
    },
    creator: function creator() {
      var a = this.account;
      if (a && a.contract) {
        return a.contract.creator;
      }
      return '';
    },
    contractCreateAt: function contractCreateAt() {
      var a = this.account;
      if (a && a.contract) {
        return a.contract.transaction;
      }
      return '';
    },
    completeTransactionCount: function completeTransactionCount() {
      var a = this.account;
      if (a && a.total_transactions) {
        return a.total_transactions;
      } else {
        return 0;
      }
    },
    lastUpdate: function lastUpdate() {
      var a = this.account;
      if (a && a.transactions) {
        return this.$utils.formatTimestamp(a.transactions[0].timestamp).toLocaleString();
      } else {
        return 'N/A';
      }
    },
    qrAddress: function qrAddress() {
      return window.location.protocol + '//' + window.location.host + '/#/account/' + this.$route.params.account;
    }
  })
});

/***/ }),

/***/ "6txk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'account-transaction-table',
  computed: {
    coinName: function coinName() {
      return this.$COINNAME;
    }
  },
  methods: {
    isMe: function isMe(t) {
      if (t.from && this.address) {
        return t.from.toLowerCase() === this.address.toLowerCase();
      } else {
        return false;
      }
    },
    arrowClass: function arrowClass(t) {
      return this.isMe(t) ? 'fa fa-arrow-circle-right' : 'fa fa-arrow-circle-left';
    },
    typeDesc: function typeDesc(t) {
      if (t.what === 'contract_creation') {
        return this.$t('table.contract_creation');
      } else if (t.what === 'contract_invoke') {
        return this.$t('table.contract_invoke');
      }
      return this.isMe(t) ? this.$t('table.send') : this.$t('table.receive');
    },
    isContract: function isContract(t) {
      return t.what !== '';
    },
    otherAddress: function otherAddress(t) {
      var add = this.isMe(t) ? t.to : t.from;
      return add;
    },
    typeStyle: function typeStyle(t) {
      if (this.isContract(t)) {
        return 'has-text-info';
      }
      return this.isMe(t) ? 'has-text-danger' : 'has-text-success';
    },
    amountStyle: function amountStyle(t) {
      return 'has-text-dark';
      // return this.isMe(t) ? 'has-text-danger' : 'has-text-success'
    },
    amountSymbol: function amountSymbol(t) {
      return !this.isMe(t) ? '+' : '-';
    }
  },
  props: ['address', 'transactions']
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "7aLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainContent_vue__ = __webpack_require__("gHvV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f48b39e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainContent_vue__ = __webpack_require__("ZmjD");
function injectStyle (ssrContext) {
  __webpack_require__("cecJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f48b39e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f48b39e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8K5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_ExtraEvent__ = __webpack_require__("RR+n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_qrcode__ = __webpack_require__("8Vd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Transaction',
  components: { ExtraEvent: __WEBPACK_IMPORTED_MODULE_1__components_layout_ExtraEvent__["a" /* default */], QRCode: __WEBPACK_IMPORTED_MODULE_2__xkeshi_vue_qrcode__["a" /* default */] },
  mounted: function mounted() {
    this.$store.dispatch('loadTransaction', this.$route.params.hash.toLowerCase());
  },
  data: function data() {
    return {
      isShowingQR: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['tx', 'receipt', 'extra', 'txJson', 'receiptJson']), {
    isEmpty: function isEmpty() {
      return this.$_.isEmpty(this.tx);
    },
    isInvoke: function isInvoke() {
      return this.tx.what === 'contract_invoke';
    },
    isDeploy: function isDeploy() {
      return this.tx.what === 'contract_creation';
    },
    isTransaction: function isTransaction() {
      return this.tx.what === '';
    },
    status: function status() {
      if (this.receipt && this.receipt.status) {
        return parseInt(this.receipt.status);
      } else {
        return 0;
      }
    },
    contractAddr: function contractAddr() {
      if (this.extra.contract) {
        return this.extra.contract;
      } else {
        return 'CONTRACT INVOKE';
      }
    },
    contractName: function contractName() {
      if (this.extra.contract) {
        return this.extra.contract;
      } else {
        return 'N/A';
      }
    },
    methodName: function methodName() {
      if (this.extra.method) {
        return this.extra.method;
      } else {
        return 'N/A';
      }
    },
    qrAddress: function qrAddress() {
      return window.location.protocol + '//' + window.location.host + '/#/tx/' + this.$route.params.hash;
    }
  })
});

/***/ }),

/***/ "9UqH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aocf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'carousel',
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])(['chainStatus']), {
    blocks: function blocks() {
      return this.$utils.addComma(this.chainStatus.blockHeight);
    },
    lastBlockTime: function lastBlockTime() {
      if (this.chainStatus.lastBlockTime) {
        var last = this.chainStatus.lastBlockTime;
        var d = new Date();
        var now = d.getTime();
        if (now / 1000 - last < 30) {
          return '' + parseInt(now / 1000 - last) + 's';
        } else {
          return this.$utils.fromNow(last);
        }
      } else {
        return 'n/a';
      }
    },
    transactionPerSecond: function transactionPerSecond() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3);
    }
  })
});

/***/ }),

/***/ "DDB0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_NprogressContainer_vue__ = __webpack_require__("JrlJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e01713fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_NprogressContainer_vue__ = __webpack_require__("nKwt");
function injectStyle (ssrContext) {
  __webpack_require__("Wr22")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_NprogressContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e01713fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_NprogressContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FcT4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GPhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavBar__ = __webpack_require__("+dZs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatusBar__ = __webpack_require__("XwRq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MainContent__ = __webpack_require__("7aLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FooterBar__ = __webpack_require__("1O7p");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__NavBar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__StatusBar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__MainContent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__FooterBar__["a"]; });










/***/ }),

/***/ "GgrH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H9Lx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in","enter-active-class":"fadeIn","leave-active-class":"fadeOut","appear":""}},[_c('div',{staticClass:"status-bar"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"level is-mobile"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('span',{staticClass:"menu-label"},[_vm._v("\n            BLOCKS\n          ")]),_vm._v("\n           "+_vm._s(_vm.blocks)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered is-hidden-mobile"},[_c('span',{staticClass:"menu-label"},[_vm._v("\n            LASTEST\n          ")]),_vm._v("\n           "+_vm._s(_vm.lastBlockTime)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"level-item has-text-centered"},[_c('span',{staticClass:"menu-label"},[_vm._v("\n            TX/SEC\n          ")]),_vm._v("\n           "+_vm._s(_vm.transactionPerSecond)+"\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HHKP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HJCT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css__ = __webpack_require__("OlBK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_flag_icon_css_css_flag_icon_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NavBar',
  methods: {
    onSubmit: function onSubmit() {
      var search = this.search;
      if (!search) {
        return;
      }
      if (search.length <= 42) {
        this.$router.push({ name: 'Contract', params: { hash: search } });
      } else {
        this.$router.push({ name: 'Transaction', params: { hash: search } });
      }
    },
    getLangName: function getLangName(l) {
      return this.langNames[l];
    },
    getLangFlag: function getLangFlag(l) {
      return 'flag-icon flag-icon-' + this.langFlags[l];
    }
  },
  data: function data() {
    return {
      search: '',
      langs: ['zhs', 'en', 'ja'],
      langNames: {
        'zhs': '简体中文',
        'en': 'English',
        'ja': '日本語'
      },
      langFlags: {
        'zhs': 'cn',
        'en': 'us',
        'ja': 'jp'
      }
    };
  }
});

/* burger navigation */
document.addEventListener('DOMContentLoaded', function () {
  // Get all "navbar-burger" elements
  var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach(function ($el) {
      $el.addEventListener('click', function () {
        // Get the target from the "data-target" attribute
        var target = $el.dataset.target;
        var $target = document.getElementById(target);
        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
        $el.classList.toggle('is-active');
        $target.classList.toggle('is-active');
      });
    });
  }
});

/***/ }),

/***/ "HeUk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contract_vue__ = __webpack_require__("564C");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681cf070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contract_vue__ = __webpack_require__("MGkH");
function injectStyle (ssrContext) {
  __webpack_require__("xQfv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-681cf070"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contract_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_681cf070_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contract_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





// https://appdividend.com/2018/05/08/vuex-axios-get-request-tutorial-with-example/#Step_5_Create_an_action

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var debug = "production" !== 'production';
var API_HOST = window.location.protocol + '//' + window.location.host + '/api/';
var API2_HOST = window.location.protocol + '//' + window.location.host + '/api2/';
if (debug) {
  API_HOST = window.location.protocol + '//localhost:19351/api/';
  API2_HOST = window.location.protocol + '//localhost:19352/api2/';
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    noticeObject: {},
    account: {},
    block: {},
    blocksOverview: [],
    chainStatus: {
      blockHeight: 0,
      transactionsPerDay: 0,
      transactionsPerHour: 0,
      transactionsPerMin: 10,
      latestTransactions: [],
      txSamples: [],
      peers: 0,
      frontiers: 0,
      lastBlockTime: 0
    },
    tx: {},
    receipt: {},
    extra: {},
    txJson: '',
    receiptJson: '',
    contract: {},
    loading: false,
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    }
  },
  getters: {
    blocksOverview: function blocksOverview(state) {
      return state.blocksOverview;
    },
    chainStatus: function chainStatus(state) {
      return state.chainStatus;
    },
    account: function account(state) {
      return state.account;
    },
    tx: function tx(state) {
      return state.tx;
    },
    receipt: function receipt(state) {
      return state.receipt;
    },
    extra: function extra(state) {
      return state.extra;
    },
    contract: function contract(state) {
      return state.contract;
    }
  },
  actions: {
    setLoading: function setLoading(_ref, isLoading) {
      var commit = _ref.commit;

      commit('SET_LOADING', isLoading);
    },
    loadAccount: function loadAccount(_ref2, address) {
      var commit = _ref2.commit;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(API_HOST + 'address/' + address).then(function (resp) {
        commit('SET_ACCOUNT', resp.data);
      }).catch(function (e) {
        commit('SET_ACCOUNT');
      });
    },
    loadBlock: function loadBlock(_ref3, hash) {
      var commit = _ref3.commit;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(API_HOST + 'block/' + hash).then(function (resp) {
        commit('SET_BLOCK', resp.data);
      }).catch(function (e) {
        commit('SET_BLOCK');
      });
    },
    loadBlocksOverview: function loadBlocksOverview(_ref4) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(API_HOST + 'blocks/overview').then(function (resp) {
        commit('SET_BLOCKS_OVERVIEW', resp.data);
      }).catch(function (e) {
        commit('SET_BLOCKS_OVERVIEW');
      });
    },
    loadTransaction: function loadTransaction(_ref5, hash) {
      var commit = _ref5.commit;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(API2_HOST + 'tx/' + hash).then(function (resp) {
        commit('SET_TRANSACTION', resp.data);
      }).catch(function (e) {
        commit('SET_TRANSACTION');
      });
    },
    loadContract: function loadContract(_ref6, hash) {
      var commit = _ref6.commit;

      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(API2_HOST + 'contract/' + hash).then(function (resp) {
        commit('SET_CONTRACT', resp.data);
      }).catch(function (e) {
        commit('SET_CONTRACT');
      });
    }
  },
  mutations: {
    SET_LOADING: function SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },
    SET_ACCOUNT: function SET_ACCOUNT(state, account) {
      state.account = account || {};
    },
    SET_BLOCK: function SET_BLOCK(state, block) {
      state.block = block || {};
    },
    SET_BLOCKS_OVERVIEW: function SET_BLOCKS_OVERVIEW(state, data) {
      state.blocksOverview = data || [];
    },
    SET_TRANSACTION: function SET_TRANSACTION(state, data) {
      state.tx = data || {};
      // receipt
      if (data && data.receipt) {
        state.receipt = JSON.parse(data.receipt);
      } else {
        state.receipt = {};
      }

      var t = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.tx));
      delete t.what;
      delete t.extra;
      delete t.receipt;
      state.txJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(t, undefined, 2);
      state.receiptJson = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.receipt, undefined, 2);

      // extra
      if (data && data.extra) {
        state.extra = data.extra;
        if (data.extra.arguments) {
          state.extra.arguments = JSON.parse(data.extra.arguments);
        } else {
          state.extra.arguments = {};
        }
      } else {
        state.extra = {};
      }
    },
    SET_CONTRACT: function SET_CONTRACT(state, data) {
      state.contract = {};
      if (data && data.name) {
        state.contract.name = data.name;
      }
      if (data && data.events && data.events.length > 0) {
        state.contract.events = [];
        for (var i in data.events) {
          var event = data.events[i];
          state.contract.events[i] = event;
          if (event.input && event.input.startsWith('{')) {
            state.contract.events[i].input = JSON.parse(event.input);
          }
        }
      }
    },

    // Websocket
    SOCKET_ONOPEN: function SOCKET_ONOPEN(state, event) {
      state.socket.isConnected = true;
    },
    SOCKET_ONCLOSE: function SOCKET_ONCLOSE(state, event) {
      state.socket.isConnected = false;
    },
    SOCKET_ONERROR: function SOCKET_ONERROR(state, event) {
      console.error(state, event);
    },

    // default handler called for all methods
    SOCKET_ONMESSAGE: function SOCKET_ONMESSAGE(state, message) {
      state.socket.message = message;
      try {
        var data = JSON.parse(message.data);
        // if (data['what'] === 'chain-status') {
        if (data.what === 'chain-status' && data.data) {
          var status = data.data;
          state.chainStatus.blockHeight = status && status.block_height ? status.block_height : 0;
          state.chainStatus.transactionsPerDay = status && status.transaction_per_day ? status.transaction_per_day : 0;
          state.chainStatus.transactionsPerHour = status && status.transaction_per_hour ? status.transaction_per_hour : 0;
          state.chainStatus.transactionsPerMin = status && status.transaction_per_min ? status.transaction_per_min : 0;
          state.chainStatus.latestTransactions = status && status.transactions ? status.transactions : [];
          state.chainStatus.txSamples = status && status.tx_samples ? status.tx_samples : [];
          state.chainStatus.peers = status && status.peers ? status.peers : 0;
          state.chainStatus.frontiers = status && status.frontiers ? status.frontiers : 0;
          state.chainStatus.lastBlockTime = status && status.last_block_time ? status.last_block_time : 0;
        }
      } catch (e) {}
    },

    // mutations for reconnect methods
    SOCKET_RECONNECT: function SOCKET_RECONNECT(state, count) {
      console.info(state, count);
    },
    SOCKET_RECONNECT_ERROR: function SOCKET_RECONNECT_ERROR(state) {
      state.socket.reconnectError = true;
    }
  },
  strict: debug
}));

/***/ }),

/***/ "JM45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-four-fifths"},[_c('div',[_c('div',{staticClass:"menu-label is-size-6"},[_c('span',{staticClass:"fa fa-cube"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("block.block")))])]),_vm._v(" "),_c('code',{staticClass:"is-size-6 has-text-weight-bold"},[_vm._v("\n              "+_vm._s(_vm.$route.params.hash)+"\n            ")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.date")))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(_vm.$utils.formatTimestamp(_vm.block.timestamp)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.difficulty")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.block.difficulty))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.extra_data")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.block.extra_data))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.gas_limit")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.block.gas_limit))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.gas_used")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.block.gas_used))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.number")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.block.number))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.nonce")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.block.nonce || 0))])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.parent")))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/block/'+ _vm.$utils.formatHash(_vm.block.parent_hash)}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(_vm.$utils.formatHash(_vm.block.parent_hash)))])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.size")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.block.size))])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t("block.transactions", {count: _vm.transactionCount})))]),_vm._v(" "),_c('block-transaction-table',{attrs:{"transactions":_vm.transactions}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t("res.json_rep")))]),_vm._v(" "),_c('blockquote',[_c('code',{staticClass:"breakable"},[_vm._v(_vm._s(_vm.json))])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JrlJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nprogress-container'
});

/***/ }),

/***/ "JuqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transaction_vue__ = __webpack_require__("8K5v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ed4729_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transaction_vue__ = __webpack_require__("XP7O");
function injectStyle (ssrContext) {
  __webpack_require__("ZEwS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32ed4729"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transaction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ed4729_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transaction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KTuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_LineChart__ = __webpack_require__("esM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_LiveTag__ = __webpack_require__("UO/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BlocksOverview',
  components: { LiveTag: __WEBPACK_IMPORTED_MODULE_2__components_layout_LiveTag__["a" /* default */], LineChart: __WEBPACK_IMPORTED_MODULE_1__components_layout_LineChart__["a" /* default */] },
  mounted: function mounted() {
    this.$store.dispatch('loadBlocksOverview');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['blocksOverview', 'chainStatus']), {
    blockArray: function blockArray() {
      return this.blocksOverview.slice(0);
    },
    blockHeight: function blockHeight() {
      return this.chainStatus.blockHeight;
    },
    blockData: function blockData() {
      var _this = this;

      return {
        labels: this.blockArray.map(function (d) {
          return _this.$utils.formatTimestamp(d.timestamp);
        }),
        datasets: [{
          label: 'blocks',
          fill: false,
          lineTension: 0.3,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#000',
          pointBorderWidth: 5,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.blockArray.map(function (d) {
            return d.height;
          }),
          spanGaps: true
        }]
      };
    }
  }),
  data: function data() {
    return {
      blockOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      }
    };
  }
});
// TODO: recharts http://recharts.org/zh-CN

/***/ }),

/***/ "Kj2I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column has-network-bg has-text-left is-size-5 has-text-weight-semibold"},[_c('div',{staticClass:"columns is-marginless third-height"},[_c('div',{staticClass:"column has-text-white"},[_vm._v("\n          BLOCKS\n        ")]),_vm._v(" "),_c('div',{staticClass:"column has-text-info"},[_vm._v("\n          "+_vm._s(_vm.blocks)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"columns is-marginless third-height"},[_c('div',{staticClass:"column has-text-white"},[_vm._v("\n          LATEST\n        ")]),_vm._v(" "),_c('div',{staticClass:"column has-text-info"},[_vm._v("\n          "+_vm._s(_vm.lastBlockTime)+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"columns is-marginless third-height"},[_c('div',{staticClass:"column has-text-white"},[_vm._v("\n          TX/SEC\n        ")]),_vm._v(" "),_c('div',{staticClass:"column has-text-info"},[_vm._v("\n          "+_vm._s(_vm.transactionPerSecond)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"column is-9"},[_c('agile',{attrs:{"arrows":false,"speed":1200,"autoplaySpeed":5000,"timing":'linear',"fade":true,"autoplay":true,"pauseOnHover":false}},[_c('div',{staticClass:"slide slide--1"}),_vm._v(" "),_c('div',{staticClass:"slide slide--2"}),_vm._v(" "),_c('div',{staticClass:"slide slide--3"})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KnKU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticker-transaction-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t("table.date")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.account")))]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile"},[_vm._v(_vm._s(_vm.$t("table.hash")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.amount")))])])]),_vm._v(" "),_vm._l((_vm.transactions),function(transaction){return _c('tbody',{key:transaction.hash},[_c('tr',[_c('td',{staticClass:"date"},[_vm._v("\n          "+_vm._s(_vm.$utils.formatTimestamp(transaction.timestamp))+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"account"},[_c('a',{staticClass:"has-text-dark",attrs:{"href":'#/account/'+ transaction.from}},[_vm._v("\n            "+_vm._s(transaction.from)+"\n          ")])]),_vm._v(" "),_c('td',{staticClass:"hash is-hidden-mobile"},[_c('a',{staticClass:"has-text-dark",attrs:{"href":'#/tx/'+ _vm.$utils.formatHash(transaction.hash)}},[_vm._v("\n            "+_vm._s(_vm.$utils.formatHash(transaction.hash))+"\n          ")])]),_vm._v(" "),_c('td',{staticClass:"amount",class:_vm.amountType()},[_vm._v("\n          "+_vm._s(_vm.$utils.formatAmount(transaction.value))+" ")])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M7uO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer-bar'
});

/***/ }),

/***/ "M8OM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invocation-event"},[(!_vm.isEmpty)?_c('div',[(_vm.isDeployVendor)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[_c('p',{staticClass:"title is-6"},[_c('a',{attrs:{"href":'#/account/' + _vm.args.owner}},[_vm._v("\n                  "+_vm._s(_vm.args.name)+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n            "+_vm._s(_vm.args.desc)+"\n            "),_c('br'),_vm._v(" "),_c('time',{attrs:{"datetime":"2016-1-1"}},[_vm._v(_vm._s(_vm.$utils.formatTimestamp(_vm.args.timestamp)))])])])]):_vm._e(),_vm._v(" "),(_vm.isProduct)?_c('div',{staticClass:"card product"},[_c('div',{staticClass:"card-image"},[_c('figure',{staticClass:"image is-square"},[_vm._v("\n            "+_vm._s(_vm.videoUrl = _vm.args.image + '?vframe/jpg/offset/1/w/180/h/320')+"\n            "),(_vm.args.image.includes('.mp4'))?_c('a',{attrs:{"href":_vm.args.image}},[_c('img',{attrs:{"src":_vm.videoUrl,"alt":"Placeholder video"}})]):_c('img',{attrs:{"src":_vm.args.image,"alt":"Placeholder image"}})])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[_c('p',{staticClass:"title is-4"},[_vm._v("\n                "+_vm._s(_vm.args.name)+"\n              ")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-6"},[_c('barcode',{attrs:{"value":_vm.args.barcode,"height":"60","lineColor":"#363636"}},[_vm._v("Invalid Barcode")])],1)])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n            "+_vm._s(_vm.args.desc)+"\n            "),_c('br'),_vm._v(" "),_c('time',{attrs:{"datetime":"2016-1-1"}},[_vm._v(_vm._s(_vm.$utils.formatTimestamp(_vm.args.timestamp)))])])])]):_vm._e(),_vm._v(" "),(_vm.isAddOperation)?_c('div',{staticClass:"card product"},[_c('div',{staticClass:"card-image"},[_c('figure',{staticClass:"image is-square"},[_c('img',{attrs:{"src":_vm.args.image,"alt":"Placeholder image"}})])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[_c('p',{staticClass:"title is-4"},[_vm._v("\n                "+_vm._s(_vm.args.name)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("\n            "+_vm._s(_vm.args.desc)+"\n            "),_c('br'),_vm._v(" "),_c('time',{attrs:{"datetime":"2016-1-1"}},[_vm._v(_vm._s(_vm.$utils.formatTimestamp(_vm.args.timestamp)))])])])]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2769ef53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("4k2Z");
function injectStyle (ssrContext) {
  __webpack_require__("X4/G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2769ef53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MGkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[(!_vm.isEmpty)?_c('div',[_c('div',{staticClass:"menu-label is-size-6"},[_c('span',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v("CONTRACT")]),_vm._v(" "),_c('span',{staticClass:"has-text-info",on:{"click":function($event){_vm.isShowingQR = !_vm.isShowingQR}}},[_c('i',{staticClass:"fa fa-qrcode"})])]),_vm._v(" "),_c('b-collapse',{attrs:{"open":_vm.isShowingQR},on:{"update:open":function($event){_vm.isShowingQR=$event}}},[_c('div',{staticClass:"content"},[_c('QRCode',{attrs:{"value":_vm.qrAddress,"options":{ size: 160 }}})],1)])],1):_vm._e(),_vm._v(" "),_c('code',{staticClass:"is-size-5 has-text-weight-bold"},[_vm._v("\n        "+_vm._s(_vm.$route.params.hash)+"\n      ")]),_vm._v(" "),(_vm.contract.name)?_c('div',{staticClass:"timeline"},[_c('header',{staticClass:"timeline-header"},[_c('span',{staticClass:"tag is-medium is-primary"},[_vm._v(_vm._s(_vm.contract.name))])]),_vm._v(" "),_vm._l((_vm.contract.events),function(event,key){return _c('div',{key:key,staticClass:"timeline-item is-primary"},[_c('div',{staticClass:"timeline-marker is-icon",class:{'is-primary': !event.pending, 'is-warning': event.pending}},[(event.event_name==='OwnershipTransferred')?_c('i',{staticClass:"fa fa-exchange"}):(event.event_name==='VendorDeployed')?_c('i',{staticClass:"fa fa-plus"}):(event.event_name==='ProductDeployed')?_c('i',{staticClass:"fa fa-cubes"}):(event.event_name==='OperatorAdded')?_c('i',{staticClass:"fa fa-user-plus"}):(event.event_name==='OperatorRemoved')?_c('i',{staticClass:"fa fa-user-times"}):(event.event_name==='ProducerAdded')?_c('i',{staticClass:"fa fa-truck"}):(event.event_name==='ProducerRemoved')?_c('i',{staticClass:"fa fa-bomb"}):(event.event_name==='ProductItemAdded')?_c('i',{staticClass:"fa fa-cube"}):(event.event_name==='OperationAdded')?_c('i',{staticClass:"fa fa-wrench"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"timeline-content"},[_c('p',{staticClass:"heading"},[_c('a',{attrs:{"href":'#/tx/' + event.transaction}},[_vm._v("\n                "+_vm._s(event.event_name)+"\n              ")])]),_vm._v(" "),(event.event_name==='OwnershipTransferred')?_c('div',[_c('div',[(parseInt(event.output) !== 0)?_c('p',{staticClass:"is-size-7"},[_vm._v("Previous Owner "),_c('br'),_vm._v(" "),(parseInt(event.output) !== 0)?_c('a',{staticClass:"is-size-7",attrs:{"href":'#/contract/' + event.output}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(event.output))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"is-size-7"},[_vm._v("New Owner "),_c('br'),_vm._v(" "),_c('a',{staticClass:"is-size-7",attrs:{"href":'#/contract/' + event.input}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(event.input))])])])])]):(event.event_name==='VendorDeployed')?_c('div',[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$utils.formatTimestamp(event.input.timestamp)))]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":'#/contract/' + event.input.owner}},[_vm._v(_vm._s(event.input.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(event.input.desc))])]):(event.event_name==='ProductDeployed')?_c('div',[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$utils.formatTimestamp(event.input.timestamp)))]),_vm._v(" "),_c('p',[_c('a',{attrs:{"href":'#/contract/' + event.output}},[_vm._v(_vm._s(event.input.name))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(event.input.desc))]),_vm._v(" "),_c('barcode',{attrs:{"value":event.input.barcode,"height":"60","lineColor":"#363636"}},[_vm._v("Invalid Barcode\n              ")]),_vm._v(" "),_c('figure',{staticClass:"image is-96x96"},[_c('img',{attrs:{"src":event.input.image}})])],1):(event.event_name==='OperatorAdded' || event.event_name==='ProducerAdded' || event.event_name==='OperatorRemoved' || event.event_name==='ProducerRemoved')?_c('div',[_c('p',[_c('a',{attrs:{"href":'#/contract/' + event.output}},[_vm._v("Account")])])]):(event.event_name==='ProductItemAdded')?_c('div',[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$utils.formatTimestamp(event.input.timestamp)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(event.input.number)+" ProductItem added.")])]):(event.event_name==='OperartionAdded')?_c('div',[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$utils.formatTimestamp(event.input.timestamp)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(event.input.type))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(event.input.desc))]),_vm._v(" "),_c('figure',{staticClass:"image is-96x96"},[_c('img',{attrs:{"src":event.input.image}})]),_vm._v(" "),_c('p',[_vm._v("Index: "+_vm._s(event.output))])]):_vm._e()])])}),_vm._v(" "),_c('header',{staticClass:"timeline-header"},[_c('span',{staticClass:"tag is-medium is-primary"},[_vm._v(_vm._s(_vm.contract.name))])])],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress__ = __webpack_require__("GtG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy__ = __webpack_require__("O3Oo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_utils__ = __webpack_require__("wxfA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_native_websocket__ = __webpack_require__("U8jO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_native_websocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_agile__ = __webpack_require__("nav3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_agile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_agile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__("IcnI");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// it fucks up buefy customization see https://github.com/buefy/buefy/issues/287
// import 'buefy/lib/buefy.css'

var coinName = 'dbt';

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$coinName = coinName;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$CoinName = coinName.toUpperCase(); // _.startCase(coinName)
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$COINNAME = coinName.toUpperCase();

// host
// Vue.prototype.$host = 'http://localhost:8088'

// axios
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_9_axios___default.a);

// websocket
var debug = "production" !== 'production';
var WS_HOST = 'wss://' + window.location.host + '/ws';
if (debug) {
  WS_HOST = 'ws://localhost:19351/ws';
  // WS_HOST = 'ws://150.109.44.202/ws'
}
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_native_websocket___default.a, WS_HOST, { store: __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */] });
__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].$socket = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$socket;

// lodash
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$_ = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a;

// utils
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$utils = __WEBPACK_IMPORTED_MODULE_7__libs_utils__["a" /* default */];

// buefy

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_buefy___default.a, {
  defaultIconPack: 'fa'
});

// nprogress

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a);

var nprogress = new __WEBPACK_IMPORTED_MODULE_3_vue_nprogress___default.a({ parent: '.nprogress-container' });

// Add a request interceptor
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.interceptors.request.use(function (config) {
  // Do something before request is sent
  __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('setLoading', true);
  nprogress.start();
  return config;
}, function (error) {
  // Do something with request error
  __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('setLoading', false);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// Add a response interceptor
__WEBPACK_IMPORTED_MODULE_9_axios___default.a.interceptors.response.use(function (response) {
  // Do something with response data
  __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('setLoading', false);
  nprogress.done();
  return response;
}, function (error) {
  // Do something with response error
  __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */].dispatch('setLoading', false);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
// i18n
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_11_vue_i18n__["a" /* default */]({
  locale: 'zhs',
  messages: {
    'en': __webpack_require__("UpdR"),
    'zhs': __webpack_require__("aipF"),
    'ja': __webpack_require__("1ccB")
  }
});

// vue-agile
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_agile___default.a);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */],
  nprogress: nprogress,
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "O0x4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_TickerTransactionTable__ = __webpack_require__("oHg+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Ticker',
  components: { TickerTransactionTable: __WEBPACK_IMPORTED_MODULE_0__components_layout_TickerTransactionTable__["a" /* default */] },
  computed: {
    transactions: function transactions() {
      return this.$store.state.chainStatus.latestTransactions.slice(0, 20);
    }
  }
});

/***/ }),

/***/ "OlBK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Omou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control has-icons-left is-expanded is-fullwidth"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input is-rounded",attrs:{"type":"text","placeholder":_vm.$t('faq.search_prompt')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-primary is-rounded",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("nav.search")))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PeSf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q4RD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RR+n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraEvent_vue__ = __webpack_require__("/vXS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4c8b24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraEvent_vue__ = __webpack_require__("M8OM");
function injectStyle (ssrContext) {
  __webpack_require__("FcT4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c4c8b24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c4c8b24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraEvent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T3b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_BlockTransactionTable__ = __webpack_require__("rr9M");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Block',
  components: { BlockTransactionTable: __WEBPACK_IMPORTED_MODULE_1__components_layout_BlockTransactionTable__["a" /* default */] },
  mounted: function mounted() {
    this.$store.dispatch('loadBlock', this.$route.params.hash);
  },

  watch: {
    '$route.params.hash': function $routeParamsHash(hash) {
      this.$store.dispatch('loadBlock', this.$route.params.hash);
    }
  },
  computed: {
    block: function block() {
      return this.$store.state.block;
    },
    transactions: function transactions() {
      var a = this.$store.state.block;
      if (a && a.transactions) {
        return a.transactions;
      } else {
        return [];
      }
    },
    transactionCount: function transactionCount() {
      var a = this.$store.state.block;
      if (a && a.transactions) {
        return a.transactions.length;
      } else {
        return 0;
      }
    },
    json: function json() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.block, undefined, 2);
    }
  }
});

/***/ }),

/***/ "UGB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('section',[_c('div',{staticClass:"notification is-light"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"has-text-weight-bold"},[_vm._v(_vm._s(_vm.$t("res.slogan", {coin: this.$CoinName})))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("res.slogan_address", {coin: this.$CoinName})))]),_vm._v(" "),_c('code',{staticClass:"has-background-light is-size-5"},[_vm._v("29ddee7880d6dd82324674776cae452c3cba13fd")])])])]),_vm._v(" "),_c('h2',[_vm._v("Voting Weight Distribution")]),_vm._v(" "),_c('live-tag'),_vm._v(" "),_c('h2',[_vm._v("\n          TODO: add representative information here\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-info is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-bar-chart"}),_vm._v("  Representatives\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("\n          Representatives are accounts which cast votes in the case of a fork in the network. Learn more about representatives in the docs.\n        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UO/9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiveTag_vue__ = __webpack_require__("jbqh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2058990b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiveTag_vue__ = __webpack_require__("iw0y");
function injectStyle (ssrContext) {
  __webpack_require__("0Ya+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2058990b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiveTag_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2058990b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiveTag_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UOlw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_TransactionTable__ = __webpack_require__("5SWH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_NetworkStatus__ = __webpack_require__("wiEL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_LiveTag__ = __webpack_require__("UO/9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Carousel__ = __webpack_require__("vy4r");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  components: { Carousel: __WEBPACK_IMPORTED_MODULE_3__components_layout_Carousel__["a" /* default */], LiveTag: __WEBPACK_IMPORTED_MODULE_2__components_layout_LiveTag__["a" /* default */], NetworkStatus: __WEBPACK_IMPORTED_MODULE_1__components_layout_NetworkStatus__["a" /* default */], TransactionTable: __WEBPACK_IMPORTED_MODULE_0__components_layout_TransactionTable__["a" /* default */] }
});

/***/ }),

/***/ "UpdR":
/***/ (function(module, exports) {

module.exports = {"ad":{"title":"📢Advertise your project on {coin}!","content":"Get your {coin} project discovered for a low monthly price with Community Ads.","footer":"COMMUNITY AD"},"nav":{"home":"HOME","tracer_home":"TRACER HOME","faq":"FAQ","network_stats":"Network Stats","blocks":"Block","representatives":"Representatives","document":"Document","search_prompt":"address, block hash","search":"Search"},"network":{"num_of_blocks":"NUMBER OF BLOCKS","num_of_frontiers":"NUMBER OF FRONTIERS","connected_peers":"CONNECTED PEERS","tx":"TX/SEC (30 MIN AVG)"},"table":{"account":"Account","amount":"Amount","block_hash":"Block Hash","block_number":"Block Number","date":"Date","difficulty":"Difficulty","extra_data":"Extra Data","from":"From","gas":"Gas","gas_limit":"Gas Limit","gas_price":"Gas Price","gas_used":"Gas Used","hash":"Hash","name":"Name","nonce":"Nonce","number":"Number","parent":"Parent","receive":"RECEIVE","send":"SEND","size":"Size","to":"To","type":"Type","contract_creation":"Create Contract","contract_invoke":"Contract Execution","contract_exec_success":"Contract Execution Completed","contract_exec_failed":"Contract Execution Failed","is_contract":"This transaction is a contract deployment"},"res":{"latest_transactions":"Latest Transactions","more":"more","slogan":"Help decentralize the {coin} network!","slogan_address":"Set your account representative to the {coin} representative.","market_data":"Market Data","live":"LIVE","market_name":"CoinMarketCap","market_desc":"{coin} is currently ranked #{rank} on {link}. The total circulating supply is 1,145,148,101,919 {coin}, which will never increase.","market_cap":"MARKET CAP","change_24h":"CHANGE (24H)","change_7d":"CHANGE (7D)","price_usd":"PRICE (USD)","price_btc":"PRICE (BTC SATOSHI)","volume_24h":"24H VOLUME","netstat_desc":"A {block} represents a send, receive or open transaction. A {frontier} represents one account in a wallet. {tx} is the total throughput of the network, which theoretically has capacity of 7,000tx/s max.","block":"block","tx_per_sec":"Tx/sec","frontier":"frontier","representative_desc":"Don't know where to start? Here are some interesting accounts to check out.","json_rep":"JSON Representation"},"faq":{"title":"Frequently Asked Questions","q_what_is":"What is {coin}?","a_what_is":"{coin} is a next-gen cryptocurrency created by JZM.io with virtually instant transactions and no fees. It uses block-lattice technology to enable fast decentralized processing without sacrificing security."},"blocks":{"blocks":"Blocks","desc":"Blocks represent transactions in the network. Learn more about blocks in the docs.","total_blocks":"Total Blocks","current_block_count":"CURRENT BLOCK COUNT"},"doc":{"key_concepts":"Key Concepts","introduction":"Introduction"},"account":{"anonymous":"ANONYMOUS ACCOUNT","contract":"CONTRACT ACCOUNT","creator":"Creator","from_transaction":"From Transaction","pending":"Pending Transactions","send":"send","receive":"receive","pending_desc":"This is a list of incoming {send} blocks for which the account holder has not yet published a {receive} block to complete the transaction.","pending_note":"Note: Only shows pending send transactions, and only up to 20 will appear, in no particular order.","no_pending":"No pending transactions.","completed":"{count} Completed Transactions","update":"This account was last updated {date}","voting_title":"Voting Weight","voting_content":"This account has {weight} voting weight."},"transaction":{"transaction":"TRANSACTION"},"block":{"block":"BLOCK","transactions":"This block contains {count} transactions"}}

/***/ }),

/***/ "WM8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"is-flex section-title bg-tx"},[_c('h2',{staticClass:"has-text-info is-marginless"},[_vm._v(_vm._s(_vm.$t("res.latest_transactions")))])]),_vm._v(" "),_c('ticker-transaction-table',{attrs:{"transactions":_vm.transactions}}),_vm._v(" "),_c('br')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wr22":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X4/G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XP7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"menu-label is-size-6"},[(!_vm.isEmpty)?_c('div',[(_vm.isTransaction)?_c('div',[_c('span',{staticClass:"fa fa-paper-plane"}),_vm._v(" "),_c('span',[_vm._v("TRANSACTION")]),_vm._v(" "),_c('span',{staticClass:"has-text-info",on:{"click":function($event){_vm.isShowingQR = !_vm.isShowingQR}}},[_c('i',{staticClass:"fa fa-qrcode"})])]):_c('div',[_c('span',{staticClass:"fa fa-file-text"}),_vm._v(" "),(_vm.isInvoke)?_c('span',[_vm._v(_vm._s(_vm.contractAddr))]):_c('span',[_vm._v(_vm._s(_vm.$t("table.contract_creation")))]),_vm._v(" "),_c('span',{staticClass:"has-text-info",on:{"click":function($event){_vm.isShowingQR = !_vm.isShowingQR}}},[_c('i',{staticClass:"fa fa-qrcode"})])]),_vm._v(" "),_c('b-collapse',{attrs:{"open":_vm.isShowingQR},on:{"update:open":function($event){_vm.isShowingQR=$event}}},[_c('div',{staticClass:"content"},[_c('QRCode',{attrs:{"value":_vm.qrAddress,"options":{ size: 160 }}})],1)])],1):_vm._e()]),_vm._v(" "),_c('code',{staticClass:"is-size-5 has-text-weight-bold"},[_vm._v("\n        "+_vm._s(_vm.$route.params.hash)+"\n      ")]),_vm._v(" "),(_vm.isEmpty)?_c('div',{staticClass:"notification is-warning"},[_vm._v("\n        无法找到指定的交易记录\n      ")]):_vm._e(),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[(!_vm.isEmpty)?_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.from")))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/account/' + _vm.tx.from}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(_vm.tx.from))])])])]),_vm._v(" "),(_vm.isDeploy)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.contract_address")))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/contract/' + _vm.receipt.contractAddress}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(_vm.receipt.contractAddress))])]),_vm._v(" "),(_vm.status === 1)?_c('span',[_c('b-icon',{attrs:{"pack":"fa","icon":"check-circle","type":"is-success","size":"is-small"}})],1):_vm._e(),_vm._v(" "),(_vm.status !== 1)?_c('span',[_c('b-icon',{attrs:{"pack":"fa","icon":"times-circle","type":"is-danger","size":"is-small"}})],1):_vm._e()])]):(_vm.isInvoke)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.to")))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/contract/' + _vm.tx.to}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(_vm.tx.to))])]),_vm._v(" "),(_vm.status === 1)?_c('span',[_c('b-icon',{attrs:{"pack":"fa","icon":"check-circle","type":"is-success","size":"is-small"}})],1):_vm._e(),_vm._v(" "),(_vm.status !== 1)?_c('span',[_c('b-icon',{attrs:{"pack":"fa","icon":"times-circle","type":"is-danger","size":"is-small"}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.status")))]),_vm._v(" "),_c('td',[(!_vm.tx.pending)?_c('span',[_vm._v("\n                  "+_vm._s(_vm.$t("table.mined"))+"\n                  "),_c('b-icon',{attrs:{"pack":"fa","icon":"check-circle","type":"is-success","size":"is-small"}})],1):_vm._e(),_vm._v(" "),(_vm.tx.pending)?_c('span',[_vm._v("\n                  "+_vm._s(_vm.$t("table.synchronizing"))+"\n                  "),_c('b-icon',{attrs:{"pack":"fa","icon":"spinner","type":"is-info","custom-class":"fa-pulse","size":"is-small"}})],1):_vm._e()])]),_vm._v(" "),(_vm.isDeploy)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.contract_name")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.extra.contract))])]):_vm._e(),_vm._v(" "),(_vm.isInvoke)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.contract_name")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.contractName))])])]):_vm._e(),_vm._v(" "),(_vm.isInvoke)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t("table.event")))]),_vm._v(" "),_c('td',[_c('code',[_vm._v(_vm._s(_vm.methodName))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.extra.arguments),function(value,key){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(key))]),_vm._v(" "),_c('td',[(_vm.$utils.mayBeAddress(value))?_c('a',{attrs:{"href":'#/contract/' + value}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(value))])]):(_vm.$utils.mayBeHash(value))?_c('a',{attrs:{"href":'#/tx/' + value}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(value))])]):_c('span',[_vm._v(_vm._s(value))])])])}),_vm._v(" "),(_vm.isTransaction)?_c('tr',[_c('td',[_vm._v("Value")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$utils.formatAmount(_vm.tx.value)))])]):_vm._e(),_vm._v(" "),(_vm.isTransaction)?_c('tr',[_c('td',[_vm._v("Gas")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.tx.gas))])]):_vm._e(),_vm._v(" "),(_vm.isTransaction)?_c('tr',[_c('td',[_vm._v("Gas Used")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(parseInt(_vm.receipt.gasUsed)))])]):_vm._e(),_vm._v(" "),(_vm.isTransaction)?_c('tr',[_c('td',[_vm._v("Gas Price")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.tx.gas_price))])]):_vm._e(),_vm._v(" "),(_vm.isTransaction)?_c('tr',[_c('td',[_vm._v("ChainID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.tx.chain_id))])]):_vm._e(),_vm._v(" "),(_vm.isTransaction)?_c('tr',[_c('td',[_vm._v("Nonce")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.tx.nonce))])]):_vm._e()],2)]):_vm._e()]),_vm._v(" "),(_vm.extra.arguments)?_c('div',{staticClass:"column"},[_c('ExtraEvent',{attrs:{"extra":_vm.extra}})],1):_vm._e()]),_vm._v(" "),(!_vm.isEmpty)?_c('div',[_c('h2',[_vm._v("TRANSACTION JSON")]),_vm._v(" "),_c('blockquote',[_c('code',{staticClass:"breakable"},[_vm._v(_vm._s(_vm.txJson))])]),_vm._v(" "),_c('h2',[_vm._v("RECEIPT JSON")]),_vm._v(" "),_c('blockquote',[_c('code',{staticClass:"breakable"},[_vm._v(_vm._s(_vm.receiptJson))])])]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XwRq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBar_vue__ = __webpack_require__("5vOt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308583cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBar_vue__ = __webpack_require__("H9Lx");
function injectStyle (ssrContext) {
  __webpack_require__("jLns")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-308583cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatusBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308583cf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatusBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YA7m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'transaction-table',
  computed: {
    coinName: function coinName() {
      return this.$COINNAME;
    },
    transactions: function transactions() {
      return this.$store.state.chainStatus.latestTransactions.slice(0, 10);
    }
  },
  methods: {
    amountType: function amountType() {
      return 'has-text-dark';
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__("j7e0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Docs__ = __webpack_require__("4iK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Faq__ = __webpack_require__("iW5I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Account__ = __webpack_require__("ZpuC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Transaction__ = __webpack_require__("JuqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Block__ = __webpack_require__("mSQ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_BlocksOverview__ = __webpack_require__("pcWd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Representatives__ = __webpack_require__("rEeG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_Ticker__ = __webpack_require__("0smJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_Contract__ = __webpack_require__("HeUk");













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'is-active', // for router-link
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home__["a" /* default */]
  }, {
    path: '/faq',
    name: 'Faq',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Faq__["a" /* default */]
  }, {
    path: '/docs',
    name: 'Docs',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Docs__["a" /* default */]
  }, {
    path: '/account/:account',
    name: 'Account',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Account__["a" /* default */]
  }, {
    path: '/tx/:hash',
    name: 'Transaction',
    component: __WEBPACK_IMPORTED_MODULE_6__views_Transaction__["a" /* default */]
  }, {
    path: '/block/:hash',
    name: 'Block',
    component: __WEBPACK_IMPORTED_MODULE_7__views_Block__["a" /* default */]
  }, {
    path: '/blocks',
    name: 'BlocksOverview',
    component: __WEBPACK_IMPORTED_MODULE_8__views_BlocksOverview__["a" /* default */]
  }, {
    path: 'representatives',
    name: 'Representatives',
    component: __WEBPACK_IMPORTED_MODULE_9__views_Representatives__["a" /* default */]
  }, {
    path: '/ticker',
    name: 'Ticker',
    component: __WEBPACK_IMPORTED_MODULE_10__views_Ticker__["a" /* default */]
  }, {
    path: '/contract/:hash',
    name: 'Contract',
    component: __WEBPACK_IMPORTED_MODULE_11__views_Contract__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YaHo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZEwS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZmjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main-content"},[_c('transition',{attrs:{"mode":"out-in","enter-active-class":"fadeIn","leave-active-class":"fadeOut","appear":""}},[_c('router-view',{key:_vm.$route.fullPath,staticClass:"animated"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZpuC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__("6DhF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8df37d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__("xFjx");
function injectStyle (ssrContext) {
  __webpack_require__("GgrH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8df37d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8df37d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aipF":
/***/ (function(module, exports) {

module.exports = {"ad":{"title":"📢在 {coin} 上展示您的项目!","content":"以优惠的每月计费方式让您的 {coin} 项目被更多社区成员发现.","footer":"社区广告"},"nav":{"home":"首页","tracer_home":"溯源官网","faq":"常见问题","network_stats":"网络概况","blocks":"区块","representatives":"代表节点","document":"文档","search_prompt":"地址,或区块哈希","search":"搜  索","ticker":"最新交易"},"network":{"num_of_blocks":"NUMBER OF BLOCKS","latest_block":"LASTEST BLOCK","consensus_peers":"CONSENSUS PEERS","tx":"TX/SEC (30 MIN AVG)"},"table":{"account":"账号","amount":"数额","block_hash":"Block Hash","block_number":"Block Number","date":"日期","difficulty":"Difficulty","extra_data":"Extra Data","from":"发起","gas":"Gas","gas_limit":"Gas Limit","gas_price":"Gas Price","gas_used":"Gas Used","hash":"哈希","name":"名称","nonce":"Nonce","number":"Number","parent":"Parent","receive":"收入","send":"支出","size":"Size","to":"接收","type":"类型","contract_creation":"部署合约","contract_invoke":"合约操作","contract_exec_success":"合约执行成功","contract_exec_failed":"合约执行失败","is_contract":"这笔交易是合约操作","contract_name":"合约","event":"事件","contract_address":"合约地址","status":"状态","mined":"数据已上链","synchronizing":"等待同步"},"res":{"latest_transactions":"最新交易","more":"更多","slogan":"帮助 {coin} 网络去中心化!","slogan_address":"将您的算力收益地址设置为 {coin} 的创世地址","live":"LIVE","change_24h":"CHANGE (24H)","change_7d":"CHANGE (7D)","price_usd":"PRICE (USD)","price_btc":"PRICE (BTC SATOSHI)","volume_24h":"24H VOLUME","block":"block","tx_per_sec":"Tx/sec","representative_desc":"不知道如何开始? 这里有一些有趣的账号供你浏览.","json_rep":"JSON 表示"},"faq":{"title":"常见问题解答","search_prompt":"交易 ID 或账号地址","q_what_is":"什么是 {coin}?","a_what_is":"{coin} 是由 JZM.io 开发的下一代无交易费, 实时的加密货币. 其采用的区块晶格技术能够让交易去中心化的同时保证速度和安全性."},"blocks":{"blocks":"区块","desc":"区块是区块链上的一个节点, 其可能包含交易数据. 你可以在文档中了解更多.","total_blocks":"区块总览","current_block_count":"当前区块高度"},"doc":{"key_concepts":"核心概念","introduction":"介绍"},"account":{"anonymous":"匿名账号","contract":"智能合约","creator":"创建者","from_transaction":"源自交易","pending":"等待处理的交易","send":"支出","receive":"收入","pending_desc":"这个列表仅包含了由此账号发起的等待处理的交易.","pending_note":"注意: 这里仅展示等待处理的支付交易, 最大展示 20 条, 列表中的顺序与交易实际发起的顺序无关.","no_pending":"没有交易在等待处理.","completed":"共 {count} 笔已完成的交易","update":"此账号最后更新于 {date}","voting_title":"投票权重","voting_content":"此账号的投票权重为 {weight} ."},"transaction":{"transaction":"交易"},"block":{"block":"区块","transactions":"此区块包含 {count} 笔交易"}}

/***/ }),

/***/ "bjCr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ticker-transaction-table',
  props: ['transactions'],
  computed: {
    coinName: function coinName() {
      return this.$COINNAME;
    }
  },
  methods: {
    amountType: function amountType() {
      return 'has-text-dark';
    }
  }
});

/***/ }),

/***/ "bnKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns has-text-centered"},[_c('div',{staticClass:"column has-text-centered sq"},[_c('div',[_c('p',{staticClass:"is-size-2 title has-text-info"},[_vm._v(_vm._s(_vm.$utils.addComma(_vm.chainStatus.blockHeight)))]),_vm._v(" "),_c('p',{staticClass:"heading has-text-grey-light is-size-6"},[_vm._v(_vm._s(_vm.$t("network.num_of_blocks")))])])]),_vm._v(" "),_c('div',{staticClass:"column has-text-centered sq"},[_c('div',[_c('p',{staticClass:"is-size-2 title has-text-info"},[_vm._v(_vm._s(_vm.lastBlockTime))]),_vm._v(" "),_c('p',{staticClass:"heading has-text-grey-light is-size-6"},[_vm._v(_vm._s(_vm.$t("network.latest_block")))])])]),_vm._v(" "),_c('div',{staticClass:"column has-text-centered sq"},[_c('div',[_c('p',{staticClass:"is-size-2 title has-text-info"},[_vm._v("1")]),_vm._v(" "),_c('p',{staticClass:"heading has-text-grey-light is-size-6"},[_vm._v(_vm._s(_vm.$t("network.consensus_peers")))])])]),_vm._v(" "),_c('div',{staticClass:"column has-text-centered sq"},[_c('div',[_c('p',{staticClass:"is-size-2 title has-text-info"},[_vm._v(_vm._s(_vm.transactionPerSecond))]),_vm._v(" "),_c('p',{staticClass:"heading has-text-grey-light is-size-6"},[_vm._v(_vm._s(_vm.$t("network.tx")))])])])]),_vm._v(" "),_c('line-chart',{attrs:{"data":_vm.txDataForChart,"options":_vm.chartOptions}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cecJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ciyn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ectI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"hero is-info is-bold"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_c('i',{staticClass:"fa fa-bar-chart"}),_vm._v("  "+_vm._s(_vm.$t("blocks.blocks"))+"\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("\n          "+_vm._s(_vm.$t("blocks.desc"))+"\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.$t("blocks.total_blocks")))]),_vm._v(" "),_c('live-tag'),_vm._v(" "),_c('h2',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t("blocks.current_block_count")))]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$utils.addComma(_vm.blockHeight)))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('line-chart',{attrs:{"data":_vm.blockData,"options":_vm.blockOptions}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "esM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__("UlOv");



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["a" /* Line */],
  props: ['data', 'options'],
  mounted: function mounted() {
    this.renderChart(this.data, this.options);
  },

  watch: {
    data: function data() {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.data).length) {
        this.renderChart(this.data, this.options);
      } else {
        this._chart.destroy();
      }
    }
  }
});

/***/ }),

/***/ "gHvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-content'
});

/***/ }),

/***/ "h6rv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hwh4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iW5I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__("m7NL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df0c49a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__("Omou");
function injectStyle (ssrContext) {
  __webpack_require__("hwh4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5df0c49a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df0c49a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iw0y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-info has-text-weight-bold heading"},[_vm._v(_vm._s(_vm.$t("res.live")))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j7e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("UOlw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e39e8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("5rmT");
function injectStyle (ssrContext) {
  __webpack_require__("ciyn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e39e8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jLns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jbqh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'live-tag'
});

/***/ }),

/***/ "js25":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k8NQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-transaction-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t("table.date")))]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile"},[_vm._v(_vm._s(_vm.$t("table.type")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.account")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.amount")))]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile"},[_vm._v(_vm._s(_vm.$t("table.hash")))])])]),_vm._v(" "),_vm._l((_vm.transactions),function(transaction){return _c('tbody',{key:transaction.hash},[_c('tr',[_c('td',{staticClass:"date"},[_c('a',{staticClass:"has-text-dark",attrs:{"href":'#/tx/'+ _vm.$utils.formatHash(transaction.hash)}},[_vm._v("\n            "+_vm._s(_vm.$utils.formatTimestamp(transaction.timestamp))+"\n          ")])]),_vm._v(" "),_c('td',{staticClass:"type is-hidden-mobile",class:_vm.typeStyle(transaction)},[_vm._v("\n          "+_vm._s(_vm.typeDesc(transaction))+" "),(!_vm.isContract(transaction))?_c('i',{class:_vm.arrowClass(transaction)}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"account"},[(!_vm.isContract(transaction))?_c('a',{staticClass:"has-text-dark",attrs:{"href":'#/account/'+ _vm.otherAddress(transaction)}},[_vm._v("\n            "+_vm._s(_vm.otherAddress(transaction))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isContract(transaction))?_c('span',[_c('b-icon',{attrs:{"pack":"fa","icon":"file-text","type":"is-primary","size":"is-small"}}),_vm._v(" "),_c('a',{attrs:{"href":'#/account/'+ _vm.otherAddress(transaction)}},[_vm._v("\n              "+_vm._s(_vm.otherAddress(transaction))+"\n            ")])],1):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"amount",class:_vm.amountStyle(transaction)},[_c('b',[_vm._v(_vm._s(_vm.amountSymbol(transaction))+_vm._s(_vm.$utils.formatAmount(transaction.value)))])]),_vm._v(" "),_c('td',{staticClass:"hash is-hidden-mobile"},[_c('a',{staticClass:"has-text-dark",attrs:{"href":'#/tx/'+ _vm.$utils.formatHash(transaction.hash)}},[_vm._v("\n            "+_vm._s(_vm.$utils.formatHash(transaction.hash))+"\n          ")])])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l0Gl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m7NL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Faq',
  data: function data() {
    return {
      search: ''
    };
  },

  methods: {
    onSubmit: function onSubmit() {
      var search = this.search;
      if (!search) {
        return;
      }
      if (search.length <= 42) {
        this.$router.push({ name: 'Contract', params: { hash: search } });
      } else {
        this.$router.push({ name: 'Transaction', params: { hash: search } });
      }
    }
  }
});

/***/ }),

/***/ "mMlO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_LiveTag__ = __webpack_require__("UO/9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Representatives',
  components: { LiveTag: __WEBPACK_IMPORTED_MODULE_0__components_layout_LiveTag__["a" /* default */] }
});

/***/ }),

/***/ "mSQ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Block_vue__ = __webpack_require__("T3b1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5b68b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Block_vue__ = __webpack_require__("JM45");
function injectStyle (ssrContext) {
  __webpack_require__("ndWS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d5b68b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Block_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d5b68b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Block_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKwt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nprogress-container"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nPgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"navbar is-bold"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item is-paddingless",attrs:{"to":{ name: 'Home'}}},[_c('img',{attrs:{"src":__webpack_require__("7Otq"),"alt":"DBT: DBTracer Explorer"}})]),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_c('div',{staticClass:"navbar-menu",attrs:{"id":"navbarDropdown"}},[_c('div',{staticClass:"navbar-start"},[_c('router-link',{staticClass:"navbar-item is-hidden",attrs:{"to":{ name: 'BlocksOverview' }}},[_vm._v(_vm._s(_vm.$t("nav.blocks")))])],1),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'Home'}}},[_c('span',{staticClass:"tag is-info is-medium"},[_vm._v(_vm._s(_vm.$t("nav.home")))])]),_vm._v(" "),_c('router-link',{staticClass:"is-hidden navbar-item",attrs:{"to":{ name: 'Faq'}}},[_c('span',{staticClass:"tag is-info is-medium"},[_vm._v(_vm._s(_vm.$t("nav.faq")))])]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item",attrs:{"to":{ name: 'Ticker'}}},[_c('span',{staticClass:"tag is-info is-medium"},[_vm._v(_vm._s(_vm.$t("nav.ticker")))])]),_vm._v(" "),_c('a',{staticClass:"navbar-item",attrs:{"href":"https://www.dbton.com"}},[_c('span',{staticClass:"tag is-info is-medium"},[_vm._v(_vm._s(_vm.$t("nav.tracer_home")))])]),_vm._v(" "),_c('div',{staticClass:"is-hidden navbar-item has-dropdown is-hoverable"},[_c('b-dropdown',{attrs:{"position":"is-bottom-left"},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}},[_c('a',{staticClass:"navbar-item",attrs:{"slot":"trigger"},slot:"trigger"},[_c('span',{class:_vm.getLangFlag(_vm.$i18n.locale)}),_vm._v("\n                  \n                "),_c('span',[_vm._v(_vm._s(_vm.getLangName(_vm.$i18n.locale)))])]),_vm._v(" "),_vm._l((_vm.langs),function(lang,i){return _c('div',{key:("Lang" + i)},[_c('b-dropdown-item',{staticClass:"lang",attrs:{"value":lang}},[_c('span',{class:_vm.getLangFlag(lang)}),_vm._v("\n                    \n                  "+_vm._s(_vm.getLangName(lang))+"\n                ")])],1)})],2)],1),_vm._v(" "),_c('div',{staticClass:"navbar-item"},[_c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control has-icons-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input is-shadowless is-radiusless",staticStyle:{"min-width":"260px"},attrs:{"type":"text","placeholder":_vm.$t('faq.search_prompt')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"control is-hidden"},[_c('button',{staticClass:"button is-primary",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t("nav.search")))])])])])])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-burger burger",attrs:{"data-target":"navbarDropdown"}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-right has-text-info"},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ndWS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oHg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TickerTransactionTable_vue__ = __webpack_require__("bjCr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd5ce98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TickerTransactionTable_vue__ = __webpack_require__("KnKU");
function injectStyle (ssrContext) {
  __webpack_require__("js25")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cd5ce98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TickerTransactionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cd5ce98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TickerTransactionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ouk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"columns is-centered has-text-centered"},[_c('div',{staticClass:"column is-narrow"},[_c('i',{staticClass:"fa fa-copyright"}),_vm._v("\n          "+_vm._s(_vm.$utils.thisYear())+" Copyright.\n        ")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"column is-narrow"},[_vm._v("\n          广东格兰堂信息科技有限公司\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-narrow"},[_c('a',{attrs:{"target":"_blank","href":"http://www.miitbeian.gov.cn/"}},[_vm._v("粤ICP备12001590号-7")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-narrow"},[_c('a',{attrs:{"target":"_blank","href":"http://www.cac.gov.cn/2019-03/30/c_1124305122.htm"}},[_vm._v("粤网信备 44010619364570180015 号")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pcWd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlocksOverview_vue__ = __webpack_require__("KTuq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ac69de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlocksOverview_vue__ = __webpack_require__("ectI");
function injectStyle (ssrContext) {
  __webpack_require__("54Zq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53ac69de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlocksOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ac69de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlocksOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q2vy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qP97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-transaction-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t("table.from")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.to")))]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile"},[_vm._v(_vm._s(_vm.$t("table.hash")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.amount")))])])]),_vm._v(" "),_vm._l((_vm.transactions),function(transaction){return _c('tbody',{key:transaction.hash},[_c('tr',[_c('td',{staticClass:"from"},[_c('a',{attrs:{"href":'#/account/'+ transaction.from}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(transaction.from))])])]),_vm._v(" "),_c('td',{staticClass:"to"},[(!_vm.isContract(transaction))?_c('a',{attrs:{"href":'#/account/'+ transaction.to}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(transaction.to))])]):_vm._e(),_vm._v(" "),(_vm.isContract(transaction))?_c('span',[_vm._v("\n            "+_vm._s(_vm.typeDesc(transaction))+"\n            "),_c('b-icon',{attrs:{"pack":"fa","icon":"file-text","type":"is-primary","size":"is-small"}}),_vm._v(" "),_c('a',{attrs:{"href":'#/account/'+ transaction.to}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(transaction.to))])])],1):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"hash is-hidden-mobile"},[_c('a',{attrs:{"href":'#/tx/'+ _vm.$utils.formatHash(transaction.hash)}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(_vm.$utils.formatHash(transaction.hash)))])])]),_vm._v(" "),_c('td',{staticClass:"amount has-text-success"},[_vm._v("\n          "+_vm._s(_vm.$utils.formatAmount(transaction.value))+" ")])])])})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rEeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Representatives_vue__ = __webpack_require__("mMlO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9921e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Representatives_vue__ = __webpack_require__("UGB/");
function injectStyle (ssrContext) {
  __webpack_require__("l0Gl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f9921e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Representatives_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f9921e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Representatives_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rHiN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container is-fullhd template-horizontal"},[_c('aside',{staticClass:"sidebar menu is-hidden-touch"},[_c('p',{staticClass:"menu-label"},[_vm._v(_vm._s(_vm.$t("doc.key_concepts")))]),_vm._v(" "),_c('ul',{staticClass:"menu-list"},[_c('li',[_c('a',{attrs:{"href":"#introduction"}},[_vm._v(_vm._s(_vm.$t("doc.introduction")))])])])]),_vm._v(" "),_c('div',{staticClass:"docs-content"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("doc.key_concepts")))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rJZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'block-transaction-table',
  props: ['transactions'],
  methods: {
    typeDesc: function typeDesc(t) {
      if (t.what === 'contract_creation') {
        return this.$t('table.contract_creation');
      }
      return '';
    },
    isContract: function isContract(t) {
      return t.what !== '';
    }
  },
  computed: {
    coinName: function coinName() {
      return this.$COINNAME;
    }
  }
});

/***/ }),

/***/ "rr9M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlockTransactionTable_vue__ = __webpack_require__("rJZP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57954d3b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlockTransactionTable_vue__ = __webpack_require__("qP97");
function injectStyle (ssrContext) {
  __webpack_require__("zKaL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57954d3b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlockTransactionTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57954d3b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlockTransactionTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t8v2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Docs'
});

/***/ }),

/***/ "uKUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transaction-table"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{staticClass:"is-hidden-mobile"},[_vm._v(_vm._s(_vm.$t("table.date")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.account")))]),_vm._v(" "),_c('th',{staticClass:"is-hidden-mobile"},[_vm._v(_vm._s(_vm.$t("table.hash")))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t("table.amount")))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.transactions),function(transaction){return _c('tr',{key:transaction.hash},[_c('td',{staticClass:"date is-hidden-mobile"},[_vm._v("\n          "+_vm._s(_vm.$utils.formatTimestamp(transaction.timestamp))+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"account"},[_c('a',{staticClass:"has-text-dark",attrs:{"href":'#/account/'+ transaction.from}},[_vm._v("\n            "+_vm._s(transaction.from)+"\n          ")])]),_vm._v(" "),_c('td',{staticClass:"hash is-hidden-mobile"},[_c('a',{staticClass:"has-text-dark",attrs:{"href":'#/tx/'+ _vm.$utils.formatHash(transaction.hash)}},[_vm._v("\n            "+_vm._s(_vm.$utils.formatHash(transaction.hash))+"\n          ")])]),_vm._v(" "),_c('td',{staticClass:"amount",class:_vm.amountType()},[_vm._v("\n          "+_vm._s(_vm.$utils.formatAmount(transaction.value))+" ")])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uty8":
/***/ (function(module, exports) {

module.exports = "../../static/img/more.7fc587b.png";

/***/ }),

/***/ "vy4r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__ = __webpack_require__("Aocf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d7232f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__ = __webpack_require__("Kj2I");
function injectStyle (ssrContext) {
  __webpack_require__("9UqH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Carousel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d7232f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Carousel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w83d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wh/e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wiEL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkStatus_vue__ = __webpack_require__("yHPN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603429fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetworkStatus_vue__ = __webpack_require__("bnKt");
function injectStyle (ssrContext) {
  __webpack_require__("h6rv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-603429fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NetworkStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_603429fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NetworkStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wxfA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Utils; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ethtools__ = __webpack_require__("lGrX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ethtools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ethtools__);





var Utils = function () {
  function Utils() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Utils);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Utils, null, [{
    key: 'thisYear',
    value: function thisYear() {
      var m = __WEBPACK_IMPORTED_MODULE_2_moment___default()();
      return m.format('YYYY');
    }
  }, {
    key: 'formatAmount',
    value: function formatAmount(amt, full) {
      if (!amt) {
        return 'n/a';
      }
      if (!full) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_ethtools__["formatBalance"])(amt, '(0.00 a$)');
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_3_ethtools__["formatBalance"])(amt);
      }
    }
  }, {
    key: 'formatTimestamp',
    value: function formatTimestamp(ts, fmt) {
      var timestamp = parseInt(ts) * 1000;
      var m = __WEBPACK_IMPORTED_MODULE_2_moment___default()(timestamp);
      if (fmt) {
        return m.format(fmt);
      } else {
        return m.format('YYYY/MM/DD HH:mm:ss');
      }
      // return new Date(timestamp)
    }
  }, {
    key: 'fromNow',
    value: function fromNow(ts) {
      var timestamp = parseInt(ts) * 1000;
      var m = __WEBPACK_IMPORTED_MODULE_2_moment___default()(timestamp);
      return m.fromNow();
    }
  }, {
    key: 'addComma',
    value: function addComma(num) {
      return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 'n/a';
    }
  }, {
    key: 'formatAddress',
    value: function formatAddress(address) {
      // return address ? address.replace('0x', '').toLowerCase() : ''
      return address ? address.toLowerCase() : '';
    }
  }, {
    key: 'formatHash',
    value: function formatHash(hash) {
      // return hash ? hash.replace('0x', '').toUpperCase() : ''
      return hash ? hash.toLowerCase() : '';
    }
  }, {
    key: 'mayBeAddress',
    value: function mayBeAddress(addr) {
      var reg = RegExp('0x[0-9a-fA-F]{40}');
      return reg.test(addr);
    }
  }, {
    key: 'mayBeHash',
    value: function mayBeHash(addr) {
      var reg = RegExp('0x[0-9a-fA-F]{64}');
      return reg.test(addr);
    }
  }]);

  return Utils;
}();



/***/ }),

/***/ "xFjx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-four-fifths"},[_c('div',[(!_vm.isContract)?_c('div',{staticClass:"menu-label is-size-6"},[_c('span',{staticClass:"fa fa-user-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("account.anonymous")))])]):_vm._e(),_vm._v(" "),(_vm.isContract)?_c('div',{staticClass:"menu-label is-size-6"},[_c('span',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("account.contract")))])]):_vm._e(),_vm._v(" "),_c('code',{staticClass:"is-size-6 has-text-weight-bold"},[_vm._v("\n              "+_vm._s(_vm.$route.params.account)+"\n            ")])]),_vm._v(" "),_c('live-tag'),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"has-text-success"},[_c('i',{staticClass:"fa fa-money"},[_vm._v("  ")]),_vm._v("\n              "+_vm._s(_vm.$utils.formatAmount(_vm.account.balance, true))+" ")])])],1),_vm._v(" "),_c('div',{staticClass:"column has-text-centered"},[_c('qrcode',{attrs:{"value":_vm.qrAddress,"options":{ size: 160 }}})],1)]),_vm._v(" "),(_vm.isContract)?_c('div',[_c('table',{staticClass:"table contract-overview"},[_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('account.creator')))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/account/'+ this.creator}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(this.creator))])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t('account.from_transaction')))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":'#/tx/'+ this.contractCreateAt}},[_c('code',{staticClass:"has-text-info"},[_vm._v(_vm._s(this.contractCreateAt))])])])])])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v("Pending Transactions")]),_vm._v(" "),_c('p',[_c('i18n',{attrs:{"path":"account.pending_desc","tag":"span"}},[_c('b',{attrs:{"place":"send"}},[_vm._v(_vm._s(_vm.$t("account.send")))]),_vm._v(" "),_c('b',{attrs:{"place":"receive"}},[_vm._v(_vm._s(_vm.$t("account.receive")))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"is-italic has-text-grey"},[_vm._v(_vm._s(_vm.$t("account.pending_note")))])],1),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticClass:"has-text-grey"},[_c('p',[_vm._v("\n          "+_vm._s(_vm.$t("account.no_pending"))+"\n        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t("account.completed", {count: _vm.completeTransactionCount})))]),_vm._v(" "),_c('i18n',{attrs:{"path":"account.update","tag":"p"}},[_c('b',{attrs:{"place":"date"}},[_vm._v(_vm._s(_vm.lastUpdate))])]),_vm._v(" "),_c('account-transaction-table',{attrs:{"transactions":_vm.account.transactions,"address":_vm.$route.params.account}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t("account.voting_title")))]),_vm._v(" "),_c('i18n',{attrs:{"path":"account.voting_content","tag":"p"}},[_c('b',{attrs:{"place":"weight"}},[_vm._v("0")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bulma_extensions_dist_js_bulma_extensions_min_js__ = __webpack_require__("hmi0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bulma_extensions_dist_js_bulma_extensions_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bulma_extensions_dist_js_bulma_extensions_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bulma_extensions_bulma_pageloader_dist_css_bulma_pageloader_min_css__ = __webpack_require__("PeSf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bulma_extensions_bulma_pageloader_dist_css_bulma_pageloader_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bulma_extensions_bulma_pageloader_dist_css_bulma_pageloader_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bulma_extensions_bulma_timeline_dist_css_bulma_timeline_min_css__ = __webpack_require__("w83d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bulma_extensions_bulma_timeline_dist_css_bulma_timeline_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bulma_extensions_bulma_timeline_dist_css_bulma_timeline_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_nprogress_src_NprogressContainer__ = __webpack_require__("DDB0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_layout___ = __webpack_require__("GPhf");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'nav-bar': __WEBPACK_IMPORTED_MODULE_4_components_layout___["c" /* NavBar */],
    'status-bar': __WEBPACK_IMPORTED_MODULE_4_components_layout___["d" /* StatusBar */],
    'main-content': __WEBPACK_IMPORTED_MODULE_4_components_layout___["b" /* MainContent */],
    'footer-bar': __WEBPACK_IMPORTED_MODULE_4_components_layout___["a" /* FooterBar */],
    'nprogress-container': __WEBPACK_IMPORTED_MODULE_3_vue_nprogress_src_NprogressContainer__["a" /* default */]
  },
  computed: {
    isLoading: function isLoading() {
      return this.$store.state.loading;
    },
    shouldShowPageLoader: function shouldShowPageLoader() {
      var path = this.$route.path;
      var enablePageList = ['/contract', '/tx'];
      for (var i in enablePageList) {
        if (path.startsWith(enablePageList[i])) {
          return true;
        }
      }

      return false;
    },
    pageName: function pageName() {
      var path = this.$route.path;
      if (path.startsWith('/tx')) {
        return 'Transaction';
      } else if (path.startsWith('/contract')) {
        return 'Contract';
      }
      return 'Page';
    }
  }
});

/***/ }),

/***/ "xQfv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yHPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LineChart__ = __webpack_require__("esM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'network-status',
  components: { LineChart: __WEBPACK_IMPORTED_MODULE_2__LineChart__["a" /* default */] },
  data: function data() {
    return {
      chartOptions: {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scaleOverride: true,
        scaleStepWidth: 1,
        scaleStartValue: 0
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])(['chainStatus']), {
    lastBlockTime: function lastBlockTime() {
      if (this.chainStatus.lastBlockTime) {
        var last = this.chainStatus.lastBlockTime;
        var d = new Date();
        var now = d.getTime();
        if (now / 1000 - last < 30) {
          return '' + parseInt(now / 1000 - last) + 's';
        } else {
          return this.$utils.fromNow(last);
        }
      } else {
        return 'n/a';
      }
    },
    transactionPerSecond: function transactionPerSecond() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3);
    },
    txSamples: function txSamples() {
      var samples = this.chainStatus.txSamples.slice(0);
      samples = samples.filter(function (s) {
        return s !== null;
      });
      samples.sort(function (a, b) {
        return a.timestamp === b.timestamp ? 0 : a.timestamp > b.timestamp ? 1 : -1;
      });
      return samples;
    },
    txDataForChart: function txDataForChart() {
      var _this = this;

      return {
        labels: this.txSamples.map(function (d, i) {
          if (i % 2 === 0) {
            return '';
          } else {
            return _this.$utils.formatTimestamp(d.timestamp, 'HH:mm');
          }
        }),
        datasets: [{
          label: 'tx/s',
          fill: true,
          lineTension: 0.3,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#000',
          pointBorderWidth: 5,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.txSamples.map(function (d) {
            return d.rate;
          }),
          spanGaps: true
        }]
      };
    }
  })
});

/***/ }),

/***/ "zKaL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.45caea85ce2098cdeea3.js